import translator from '@Components/Utilities/Translator';

const AVBanner = () => {
    return (
		<div class="av-banner cf">
			<a href="https://www.auctionvalues.com?gtmlt=1" target="_blank" aria-label={"Free Industrywide Auction Results View Now (" + translator.translate('sandhills.opensinanewtab') + ")"}>
				<div class="avbanner-image"></div>
				<div class="avbanner-inner cf">
					<div class="avbanner-left">
						<div class="avbanner-tagline">
							Free Industrywide Auction Results
						</div>
					</div>
					<div class="avbanner-right">
						<div class="avbanner-logo">
							<img src="/Content/images/AVPlug/logo.png" alt="Auction Values Logo" aria-hidden='true'/>
						</div>
						<div class="avbanner-button">
							View Now
						</div>
					</div>
				</div>
			</a>
		</div>
	);
}

export default AVBanner